import classNames from "classnames";

function NavButton({ text, selected, onClick }) {
  return (
    <div
      className={classNames("mx-3 cursor-pointer nav-button", {
        "nav-button-selected": selected,
        "nav-button-unselected": !selected,
      })}
      datatext={text}
      onClick={onClick}
    >
      {text}
      <hr />
    </div>
  );
}

export default NavButton;
